var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("common.nouns.status")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.Steps.FORM
    }
  }, [_c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.progressStatus'),
      "loading": _vm.isProgressStatusLoading || _vm.report.isReportGroupLoading,
      "disabled": _vm.isProgressStatusLoading,
      "items": _vm.customFieldStatus,
      "filter": _vm.autocompleteFilter
    },
    on: {
      "change": _vm.onStatusChange
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-avatar', {
          staticClass: "mr-2 white--text",
          attrs: {
            "color": item.color,
            "elevation": 0,
            "size": "14"
          }
        }), _vm._v(" " + _vm._s(item.value || item) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-avatar', {
          staticClass: "mr-2 white--text",
          attrs: {
            "color": item.color,
            "elevation": 0,
            "size": "14"
          }
        }), _vm._v(" " + _vm._s(item.value || item) + " ")];
      }
    }]),
    model: {
      value: _vm.newStatus,
      callback: function callback($$v) {
        _vm.newStatus = $$v;
      },
      expression: "newStatus"
    }
  }), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "disabled": _vm.isProgressStatusLoading,
      "label": _vm.$t('common.nouns.note')
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "outlined": "",
      "loading": _vm.isProgressStatusLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createAndClose();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.isProgressStatusLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createReportAndSend();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("saveAndSend")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.Steps.SEND_MAIL
    }
  }, [_c('v-card-text', [_vm.Steps.SEND_MAIL === _vm.step ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.UPDATE_REPORT_STATUS_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.report.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.toMail,
      "refs": [{
        refId: _vm.report.id,
        refType: _vm.ResourceEnum.REPORT
      }],
      "isTicketEnabled": true
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.isProgressStatusLoading
    },
    on: {
      "click": function click() {
        return _vm.sendMail();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }